import { faSync, IconDefinition } from '@fortawesome/pro-solid-svg-icons';
import { Component, Input, OnInit } from 'angular-ts-decorators';
import { isArray } from 'lodash';

/**
 * The bootstrap modal component for a status modal
 *
 * # Example
 * <pre>
 *   <sw-status-modal resolve="{}"></sw-status-modal>
 * </pre>
 */
@Component({
  selector: 'swStatusModal',
  template: require('./sw-status-modal.html').default,
})
export class SwStatusModalComponent implements OnInit {
  public faSync: IconDefinition = faSync;
  public isQueue: boolean = false;
  public showState: string;
  public errors: any[];
  public requests: any[];
  @Input() resolve;
  constructor(private $translate: ng.translate.ITranslateService) {
    'ngInject';
  }

  ngOnInit() {
    this.showState = this.resolve.showState;
    this.errors = this.resolve.failed;
    this.requests = this.resolve.requests;
  }

  toggleQueue(queue: string) {
    return (this.isQueue = queue === 'queue');
  }

  translate(url: string = ''): string {
    const urlMap = {
      'replenishment/add': this.$translate.instant('url.replenishment'),
    };
    const extractPath = (url) => /http:\/\/.+?\/(.+)/.exec(url);
    let path = isArray(extractPath(url)) ? extractPath(url)[1] : '';
    return urlMap[path] || this.$translate.instant('url.default');
  }
}
